/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';

/**
 * @import { IViewerSource } from '.'
 * @import { ViewerFrameFactory } from '../viewer/frame'
 */

// TODO Unit testy.
/**
 * Zdroj zobrazování médií v podobě HTML image elementu.
 * Zdrojový element je obalený do rámujícího div a s ním vložen na určené místo do DOM.
 * @implements {IViewerSource}
 */
export default class DivViewerSource {
  /**
   * Vytvoří instanci.
   * @param {ViewerFrameFactory} frameFactory
   * @param {HTMLElement} parentEl Rodičovský element, určený pro vkládání elementů zdroje.
   */
  constructor(frameFactory, parentEl) {
    // TODO Vyčlenit vytvoření elementů do samostatné public metody, než je mít v konstruktoru?
    const frame = frameFactory.create();
    const frameEl = frame.getEl();
    const el = document.createElement('div');
    frameEl.appendChild(el);
    parentEl.appendChild(frameEl);
    this.el = el;
    this.frame = frame;
    this.parentEl = parentEl;
  }

  /** @type {IViewerSource['destroy']} */
  destroy() {
    // Uvolnění img elementu zrušením jeho src.
    this.el.removeAttribute('src');
    // Odebrání frame elementu z DOM.
    const frameEl = this.frame.getEl();
    this.parentEl.removeChild(frameEl);
  }

  /** @type {IViewerSource['getEl']} */
  getEl() {
    const { el } = this;
    if (isNil(el)) {
      throw new TypeError('Missing element.');
    }
    return el;
  }

  /** @type {IViewerSource['getFrame']} */
  getFrame() {
    return this.frame;
  }

  /** @type {IViewerSource['setParentEl']} */
  setParentEl(parentEl) {
    if (!isObject(parentEl)) {
      throw new TypeError(`Invalid parent element ${parentEl}.`);
    }
    if (parentEl === this.parentEl) {
      // Pokud se rodičovský element nezmění, tak se přesun neprovádí.
      return;
    }
    // Přesun elementu do nového rodiče.
    // TODO Platformově specifické prolínače. Pro Samsung možno přidat omezení nebo ošetření přesunu.
    // - Příklad speciální implementace, která by nedovolila přesun elementu?
    const frameEl = this.frame.getEl();
    parentEl.appendChild(frameEl);
    this.parentEl = parentEl;
  }
}
